import styles from './index.module.scss';

export interface CardItemProps<> {
  key: string | number;
  className?: string;
  icon?: React.ReactNode;
  title?: React.ReactNode;
  description?: React.ReactNode;
  extra?: React.ReactNode;
  onClick?: () => void;
  showBottom?: boolean;
}

const CardItem = ({
  className,
  icon,
  title,
  description,
  extra,
  showBottom = false,
  onClick,
}: CardItemProps) => {
  return (
    <div
      className={cls(styles.cardItem, className, onClick && styles.clickable)}
      onClick={onClick}
    >
      {icon && <div className={styles.icon}>{icon}</div>}
      <div className={cls(styles.section, showBottom && styles.bottomBorder)}>
        <div className={styles.content}>
          {title && <div className={styles.title}>{title}</div>}
          {description && <div className={styles.description}>{description}</div>}
        </div>
        {extra && <div className={styles.extra}>{extra}</div>}
      </div>
    </div>
  );
};
export default CardItem;
